<template>
  <tr class="order-history__entry border border-balternative-color">
    <td v-if="entry.deliveryDate" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">
      <div
        v-if="isFutureDeliveryDate"
        class="relative group cursor-help"
      >
        {{ $formatDate(entry.deliveryDate) }}
        <div class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-white text-gray-800 text-sm rounded-lg shadow-lg border border-gray-200 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
          Dit is de verwachte leverdatum van uw bestelling. Houd er rekening mee dat deze nog kan wijzigen.
          <div class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white"></div>
        </div>
      </div>
      <span v-else>{{ $formatDate(entry.deliveryDate) }}</span>
    </td>
    <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color" v-else>Nog onbekend</td>
    <td v-if="computedIconStatus" :title=computedIconStatusTitle(entry.orderStatusIcon) class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">
       <CheckCircleIcon
         class="w-6 h-6"
        :class=getStatusClass(entry.orderStatusIcon)
         >
        </CheckCircleIcon>
    </td>
    <td v-else class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">
      <a v-if="entry.orderStatusIcon" class="text-pdsPrimaryColor" :href="entry.orderStatusIcon" target="_blank" rel="noopener">Volg bestelling</a>
    </td>
    <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">{{ entry.orderNumber }}</td>
    <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">{{ entry.orderBy }}</td>
    <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">
      {{ entry.orderDate ? $formatDate(entry.orderDate) : '' }}
    </td>
    <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">{{ entry.deliveryAddress }}</td>
    <td class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-tdefault-color">{{ entry.type }}</td>
    <td
      @click.prevent="toggleDetails()"
      class="whitespace-nowrap py-3.5 pl-4 pr-3 text-base text-pdsPrimaryColor text-end cursor"
    >
      <span>Bekijk bestelling</span>
      <ChevronDownIcon
        v-if="!collapsed"
        class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block text-secondary-hover"
        aria-hidden="true"
      />
      <ChevronUpIcon
        v-else
        class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block text-secondary-hover"
        aria-hidden="true"
      />
    </td>
  </tr>
  <tr v-if="$slots.details && collapsed">
    <td colspan="8">
      <slot name="details" />
    </td>
  </tr>
</template>

<script>
import complete from 'icons/CheckCircle';
import incomplete from 'icons/Timelapse';
import { ChevronDownIcon, ChevronUpIcon, CheckCircleIcon } from '@heroicons/vue/20/solid';
import { computed, ref } from 'vue';

export default {
  name: 'OrderHistoryEntry',
  components: {
    complete,
    incomplete,
    ChevronDownIcon,
    ChevronUpIcon,
    CheckCircleIcon
  },
  props: {
    entry: {
      type: Object,
      required: true,
      status: {
        type: Number,
        default: 0
      },
      id: {
        type: String,
        required: true
      },
      orderedby: {
        type: String
      },
      date: {
        type: Date
      },
      trackuri: {
        type: String
      }
    },
    index: {
      type: Number
    }
  },
  setup(props) {
    const collapsed = ref(false);
    const computedIconStatus = computed(() => {
      return props.entry.orderStatusIcon === 'Green' || props.entry.orderStatusIcon === 'Orange' || props.entry.orderStatusIcon  === 'Grey';
    });
    const isFutureDeliveryDate = computed(() => {
      if (!props.entry.deliveryDate) return false;
      const deliveryDate = new Date(props.entry.deliveryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return deliveryDate > today;
    });
    const computedIconStatusTitle = (status) => {
       switch (status) {
        case 'Green':
          return 'Order is verzonden';
        case 'Orange':
          return 'Order is verwerkt';
        case 'Grey':
          return 'Order is aangemaakt';
        default:
          return ''
      }
    };
   const getStatusClass = (status) => {
   switch (status) {
        case 'Green':
          return 'text-green-500 bg-white';
        case 'Orange':
          return 'text-orange-500 bg-white';
        case 'Grey':
          return 'text-gray-300 bg-white';
        default:
          return '';
      }
    }
    const toggleDetails = () => {
      collapsed.value = !collapsed.value;
    };
    return {
      collapsed,
      toggleDetails,
      computedIconStatus,
      isFutureDeliveryDate,
      computedIconStatusTitle,
      getStatusClass
    };
  }
};
</script>
<style lang="scss" scoped>
.order-history__entry {
  .material-design-icon {
    fill: $teal-darkest;
  }
}
</style>
